module.exports = __webpack_public_path__ + "static/thales-f0665c20778ff80a12d6f93e0604d76e.png";